export default __webpack_public_path__ + "static/fakturownia-logo-light-1839b20f32873f4ea4bf2789a136c721.svg";